export default __webpack_public_path__ + "static/media/btn_back.ada1f202.svg";